import React,{ useState, useEffect } from 'react';
import {AiOutlineUserAdd} from 'react-icons/ai';
import EditIconButton from "../../components/IconButtons/EditIconButton";
import DeleteIconButton from "../../components/IconButtons/DeleteIconButton";
import { TooltipComponent } from '@syncfusion/ej2-react-popups';
import { useStateContext } from '../../contexts/ContextProvider';
import {useDocumentosGeneralesMutations} from '../../hooks';
import { getDocumentosGeneralesFiltro} from "../../services/DocumentosGenerales";

import DataTable from 'react-data-table-component';
import { NuevoDocuGeneral } from '../../components';


const NavButton = ({ title, customFunc, icon, color, texto }) => (
  <TooltipComponent content={title} position="BottomCenter">
    <button
      type="button"
      onClick={() => customFunc()}
      style={{ backgroundColor: color}}
      className="relative text-xl  text-white rounded-lg p-3 hover:bg-light-gray"
    >
      <div className="flex flex-row justify-between items-center">
        <div>{icon}</div>
        <div><p className="text-xs ">{texto}</p></div>
      </div>
    
    </button>

  </TooltipComponent>
);

const DocumentosGenerales = () => {
  const { currentColor, handleClick, isClicked } = useStateContext();
  const {removeDocuGeneral} = useDocumentosGeneralesMutations();
  const [sucursalesData, setSucursalesData] = useState([]);
  const [laSucursal, setLaSucursal] = useState("");
  const [exigeFecha, setExigeFecha] = useState("ALL");
  const [vigencia, setVigencia] = useState("");
  const [nombreDocFiltro, setNombreDocFiltro] = useState("");
  const [filteredData, setFilteredData] = useState([]);


  const inputClass = "text-[11px] border border-gray-300 p-1.5 rounded-md focus:outline-none focus:ring-1 focus:ring-blue-400";


  useEffect(()=>{
    const fetchData = async () => {
      const misSucursales = await getDocumentosGeneralesFiltro(exigeFecha,vigencia);
      setSucursalesData(misSucursales);
    };
    fetchData();
  },[exigeFecha,vigencia]);

  useEffect(() => {
    if (nombreDocFiltro.trim() === "") {
      setFilteredData(sucursalesData);
    } else {
      setFilteredData(
        sucursalesData.filter(item =>
          item.documentoGeneral && item.documentoGeneral.toLowerCase().includes(nombreDocFiltro.toLowerCase())
        )
      );
    }
  }, [nombreDocFiltro, sucursalesData]);

  const handleEdit = (sucursalData) => {
    setLaSucursal(sucursalData);
    handleClick('nuevodocugeneral');
  };

  const handleEliminar = async (row) => {
    //console.log('voy a eliminar ' + row._id);
    setSucursalesData((prevData) => prevData.filter((item) => item._id !== row._id));
    await removeDocuGeneral.mutateAsync(row._id);
    setSucursalesData((prevData) =>(prevData));
  };

  const handleRefreshDataTable = (opcion) => {
    // console.log(" OPCION LLEGO -> " + opcion);
    if (opcion==="REFRESH"){
      const fetchData = async () => {
  
        const losFiados = await getDocumentosGeneralesFiltro(exigeFecha,vigencia);
    
        setSucursalesData(losFiados);
      };
      fetchData();
    }

  };

const customStyles = {
  table: {
    style: {
      backgroundColor: 'white',
      borderRadius: '8px',
    },
  },
  head: {
    style: {
      fontSize: '14px',
      fontWeight: 'bold',
      color: '#2F336A',
      backgroundColor: '#F2F5FE',
      borderBottom: '1px solid #D9E1F2',
    },
  },
  headRow: {
    style: {
      minHeight: '48px',
      borderBottomWidth: '1px',
    },
  },
  headCells: {
    style: {
      paddingLeft: '12px',
      paddingRight: '12px',
      whiteSpace: 'nowrap',
    },
  },
  rows: {
    style: {
      fontSize: '13px',
      backgroundColor: 'white',
      minHeight: '52px',
      borderBottom: '1px solid #F3F4F6',
      transition: 'background-color 0.2s ease-in-out',
    },
    highlightOnHoverStyle: {
      backgroundColor: '#F9FAFB',
      borderBottomColor: '#E5E7EB',
      outline: 'none',
    },
  },
  cells: {
    style: {
      paddingLeft: '12px',
      paddingRight: '12px',
    },
  },
};

  const columns = [
    {
      name: '',
      width: '40px',
      cell: (row) => ( <EditIconButton onClick={() => handleEdit(row)} /> )
    },
    {
      name: '',
      width: '40px',
      cell: (row) => ( <DeleteIconButton onClick={() => handleEliminar(row)} /> )
    },
    {
      name: 'Documento General',
      width: '300px',
      selector: row => row.documentoGeneral,
      sortable: true,
      cell: (row) => (
      <div className="flex items-center gap-2">
        <span>{row.documentoGeneral}</span>
      </div>
      )
    },
    {
      name: 'Descripción',
      width: '300px',
      selector: row => row.descripcion,
      sortable: true,
      cell: (row) => (
      <div className="flex items-center gap-2">
        <span>{row.descripcion}</span>
      </div>
      )
    },
    {
      name: 'Tipo',
      width: '120px',
      selector: row => row.tipo,
      sortable: true,
      cell: (row) => {
        const esObra = row.tipo === 'Obra';
        const esAnexo = row.tipo === 'Anexo';
        return (
          <span style={{
            display: 'inline-block',
            padding: '2px 10px',
            borderRadius: '12px',
            fontSize: '11px',
            fontWeight: '600',
            backgroundColor: esObra ? '#FEF3C7' : esAnexo ? '#FEE2E2' : '#DBEAFE',
            color: esObra ? '#92400E' : esAnexo ? '#991B1B' : '#1E40AF',
          }}>
            {row.tipo || 'Logística'}
          </span>
        );
      }
    },
    {
      name: 'Exige Fecha',
      width: '160px',
      selector: row => row.exigeFecha,
      sortable: true
    },
    {
      name: 'Días Vigencia',
      width: '160px',
      selector: row => row.vigencia,
      sortable: true
    }
  ];

  return (
    <>
    <div className="mx-4 lg:mx-12 mt-4">
        <div className="flex justify-between items-center px-4 py-2 border-b border-gray-200 bg-white rounded-t-md shadow-sm">
            <div className="flex items-center gap-2">
              <div className="w-2.5 h-2.5 rounded-full bg-blue-500 animate-pulse" />
              <p className="text-gray-800 font-semibold text-base md:text-lg">
                 Documentos Generales
              </p>
            </div>
        </div>
        <div className="bg-white p-6 rounded-lg shadow-lg mt-2">
          <div className="flex justify-start items-center p-2 md:ml-6 md:mr-6 relative top-1">
            <div className="grid grid-cols-1 md:grid-cols-6 gap-4 w-full">

                  <div className="flex flex-col">
                      <label className="text-xs font-semibold mb-1">Exige Fecha</label>
                      <select className={inputClass} name="exigeFecha" value= {exigeFecha} required onChange={(e) => setExigeFecha(e.target.value)}>
                        <option value="ALL">Todos</option>
                        <option value="SI">SI</option>
                        <option value="NO">NO</option>
                      </select>
                  </div>
                  <div className="flex flex-col">
                    <label className="text-xs font-semibold mb-1">Días Vigencia</label>
                    <input
                        className={inputClass}
                        type="text"
                        placeholder=""
                        name="vigencia"
                        value= {vigencia}
                        required
                        onChange={(e) => setVigencia(e.target.value)}
                      />
                  </div>

                  <div className="flex flex-col justify-end">
                    <label className="text-xs font-semibold mb-1 whitespace-nowrap">Nombre de docto.</label>
                    <input
                      type="text"
                      className={inputClass}
                      placeholder="Ej: Certificado"
                      value={nombreDocFiltro}
                      onChange={e => setNombreDocFiltro(e.target.value)}
                    />
                  </div>

                  <div className="flex items-end col-span-1">
                    <NavButton title="Agregar Documento General" customFunc={() => { setLaSucursal(''); handleClick('nuevodocugeneral')} } color={currentColor} icon={<AiOutlineUserAdd />} texto={'Nuevo Documento'} />
                  </div>
            </div>
        </div>
      </div>

    <div className="bg-white p-6 rounded-lg shadow-lg items-end mt-4">
      <div className="grid grid-cols-1 md:grid-cols-1 gap-4" >
        <div className="flex flex-col">
          <DataTable
            columns={columns}
            data={filteredData}
            highlightOnHover
            pagination={true}
            striped
            className="border border-gray-300 rounded-lg shadow-sm"
            noHeader={true}
            selectableRowsHighlight
            customStyles={customStyles}
            noDataComponent={'No hay Documentos Generales creados'}
          />

          {isClicked.nuevodocugeneral && (<NuevoDocuGeneral vecinoData={laSucursal} onChangeVecino={handleRefreshDataTable}/>)}
        </div>
      </div>
    </div>

  </div>


    </>
  );
};

export default DocumentosGenerales;